import mapSliceTypeToComponent from '~/imports/designer_page'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { SliceManager } from '@unlikelystudio/react-abstract-components'

import PageWithFilters from '~/components/PageWithFilters'
import HeroFilteredPage from '~/components/UI/HeroFilteredPage'

import getDesignerPageStaticPropsFunction from '~/data/designer-page-data'
import { DesignerPageData } from '~/data/designer-page-data/serializer'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

function DesignerPage({ slices, heroData, ...props }: DesignerPageData) {
  const { image, mobileImage } = heroData ?? {}

  const hasHeroImage = Boolean(image || mobileImage)

  return (
    <>
      <HeroFilteredPage {...heroData} />
      <PageWithFilters customLayout {...props} withPriority={!hasHeroImage}>
        <SliceManager
          mapSliceTypeToComponent={mapSliceTypeToComponent}
          slicesData={slices}
        />
      </PageWithFilters>
    </>
  )
}

export default DesignerPage

export const getStaticProps = getDesignerPageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: false,
  type: STORYBLOK_TYPES.DESIGNER,
  maxPathsInProduction: 10,
})
